//sorting the places by the name
export const sortByName = (a, b) => {
  return a.name > b.name ? 1 : -1;
};
